/* eslint-disable no-await-in-loop */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DefaultRequest = (...args: any) => Promise<unknown>;
type CheckFunction = (val: unknown) => boolean;

/**
 * This helpers handles rare requests that return valid data, but that is not expected in this case. It retries
 * the request unless the data meets the passed check function.
 * @param request A function that is called;
 * @param checkResponse A function that checks whether the response received has the expected result;
 * @param interval (OPTIONAL) Time in ms between the request calls, default is 2000 ms;
 * @param finishIn (OPTIONAL) The period after which the hook exists with any results it have currently;
 */
export async function repeatRequestFor<Request extends DefaultRequest = DefaultRequest>(
  request: Request,
  checkResponse: CheckFunction,
  interval = 2000,
  finishIn = 10000,
): Promise<ReturnType<Request> | null> {
  let finalResult = null;
  let resultIsCorrect = false;
  const startTime = Date.now();

  function hasToFinish(): boolean {
    return Date.now() - startTime >= finishIn;
  }

  while (!resultIsCorrect && !hasToFinish()) {
    const res = await new Promise<ReturnType<Request>>((resolve) => {
      // @ts-expect-error typescript does not pick up type inference that deep
      setTimeout(async () => resolve(await request()), interval);
    });

    finalResult = res;
    resultIsCorrect = checkResponse(res);
  }

  return resultIsCorrect ? finalResult : null;
}
